module.exports = __webpack_public_path__ + "static/media/district6.a606f0ea.pdf";